import { render, staticRenderFns } from "./EnquiryCabinet_Component.vue?vue&type=template&id=fc71580a&scoped=true&"
import script from "./EnquiryCabinet_Component.vue?vue&type=script&lang=js&"
export * from "./EnquiryCabinet_Component.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryCabinet_Component.vue?vue&type=style&index=0&id=fc71580a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc71580a",
  null
  
)

export default component.exports